<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 sm6 lg4 pa-1>
        <v-card>
          <!-- v-img src="https://cdn.vuetifyjs.com/images/cards/desert.jpg" aspect-ratio="2.75"></v-img -->

          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Welcome to Clac Admin Back-office</h3>
              <div>
                Lorem ipsum dolor sit amet, brute iriure accusata ne mea. Eos
                suavitate referrentur ad, te duo agam libris qualisque, utroque
                quaestio accommodare no qui. Et percipit laboramus usu, no
                invidunt verterem nominati mel. Dolorem ancillae an mei, ut
                putant invenire splendide mel, ea nec propriae adipisci. Ignota
                salutandi accusamus in sed, et per malis fuisset, qui id ludus
                appareat.
              </div>
            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn color="success">Confirm dialog</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 lg4 pa-1>
        <v-card>
          <v-card-title primary-title>
            <h3 class="headline mb-0">Search</h3>
          </v-card-title>
          <v-flex pa-3>
            <multiple-search
              @selected="selectedItem = $event"
            ></multiple-search>
          </v-flex>

          <v-card-actions></v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import { mapMutations } from "vuex";

import MultipleSearchComponent from "@/components/MultipleSearch";

export default {
  name: "Home",
  components: {
    MultipleSearch: MultipleSearchComponent
  },
  data: () => ({
    selectedItem: "",
    confirmation: {
      name: "Confirm",
      payload: {
        message: "Please confirm message",
        result: false
      }
    }
  }),
  methods: {}
};
</script>
